import BaseModel from "./_BaseModel";
import EstimasiBrg from "./EstimasiBrg";

export default class Estimasi extends BaseModel {
    public readonly ucode?: string;
    public kode?: string;
    public nama?: string;
    public aktif: boolean = true;
    public keterangan?: string;
    public list_estimasi_brg: EstimasiBrg[] = [];

    public constructor(
        ucode?: string
    ) {
        super();
        this.ucode = ucode;
    }
};
